import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { catchError, Observable, of, Subject, tap } from 'rxjs';
import { UserProfile } from '../../_models/profile/user-profile.models';
import { UserProfileService } from '../../_services/app/profile.service';
import { AuthService } from '../../_services/api/auth.service';

export interface MenuItem {
  path: string;
  label: string;
  icon: string;
  iconActive?: string;
}

@Component({
  selector: 'app-space-layout',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './space-layout.component.html',
  styleUrl: './space-layout.component.scss'
})
export class SpaceLayoutComponent implements OnInit {
  @Input() userAvatar: string = './assets/images/user-default.png';
  @Input() userFirstName: string = '';
  @Input() username: string = '';
  @Input() menuItems: MenuItem[] = [];
  @Output() onLogout = new EventEmitter<void>();

  isMobileMenuOpen = false;
  private destroy$ = new Subject<void>();
  loginUser: any;
  userId: number = 0;
  profile$!: Observable<UserProfile | null>;
  profileImage = 'default-image.jpg';

  constructor(
    private profileService: UserProfileService,
     private authService: AuthService,
  ){}

  ngOnInit(): void {
    this.loginUser = this.authService.getUserInfo();
    if (this.loginUser) {
      this.profile$ = this.profileService.profile$;
      this.userId = this.loginUser.id;
      this.username = this.loginUser.username;
      this.userFirstName = this.loginUser.firstName;
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  toggleMobileMenu(): void {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
  }

  closeMobileMenu(): void {
    this.isMobileMenuOpen = false;
  }

  loadProfile(): void {
      this.profile$ = this.profileService.profile$.pipe(
        tap(profile => {
          if (!profile) {
            this.profileService.refreshProfile().subscribe({
              error: (err) => {
              console.error('Failed to load profile');
              }
            });
          }
        }),
        catchError(err => {
          console.error('Failed to load profile');
          return of(null);
        })
      );
    }

  onImageError(event: Event) {
    const img = event.target as HTMLImageElement;
    img.src = './assets/images/user-default.png';
  }
}